<div class="d-flex flex-row">
    <div class="d-flex flex-column login-component h-100" style="gap: 30px;width: 550px;">
        <h3>Zresetuj swoje hasło</h3>

        <p>Wprowadź swoje nowe hasło poniżej. Upewnij się, że hasło spełnia wymagania bezpieczeństwa. Po zapisaniu będziesz mógł się zalogować na swoje konto.</p>

        <form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Nowe hasło</mat-label>
                <input matInput type="password" placeholder="Nowe hasło" required [errorStateMatcher]="matcher"
                    formControlName="password">
                @if (newPasswordForm.hasError('password') && !newPasswordForm.hasError('required')) {
                <mat-error>Podany adres e-mail jest nieprawidłowy</mat-error>
                }
                @if (newPasswordForm.hasError('password')) {
                <mat-error>Proszę wprowadzić hasło</mat-error>
                }
                <div class="text-red-400 text-sm" *ngIf="newPasswordForm.get('password')?.dirty">
                    <span class="block" [ngClass]="{'text-success': newPasswordForm.get('password')?.value?.match('^(?=.*[A-Z])'), 'text-danger': !newPasswordForm.get('password')?.value?.match('^(?=.*[A-Z])')}">Co najmniej jedna duża litera.</span><br>
                    <span class="block" [ngClass]="{'text-success': newPasswordForm.get('password')?.value?.match('(?=.*[a-z])')}">Co najmniej jedna mała litera.</span><br>
                    <span class="block" [ngClass]="{'text-success': newPasswordForm.get('password')?.value?.match('(.*[0-9].*)')}">Co najmniej jedna cyfra.</span><br>
                    <span class="block" [ngClass]="{'text-success': newPasswordForm.get('password')?.value?.match('(?=.*[!@#$%^&*])')}">Co najmniej jeden znak specjalny.</span><br>
                    <span class="block" [ngClass]="{'text-success': newPasswordForm.get('password')?.value?.match('.{8,}')}">Co najmniej 8 znaków.</span><br>
                 </div>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width:100%;">
                <mat-label>Powtórz nowe hasło</mat-label>
                <input matInput type="password" placeholder="Powtórz nowe hasło" required [errorStateMatcher]="matcher"
                    formControlName="password_confirm">
                @if (newPasswordForm.hasError('password_confirm') && !newPasswordForm.hasError('required')) {
                <mat-error>Podany adres e-mail jest nieprawidłowy</mat-error>
                }
                @if (newPasswordForm.hasError('password_confirm')) {
                <mat-error>Proszę wprowadzić potwierdzenie hasła</mat-error>
                }
                <div class="text-red-400 text-sm" *ngIf="newPasswordForm.get('password_confirm')?.dirty">
                    <mat-error *ngIf="newPasswordForm.get('password')?.value !== newPasswordForm.get('password_confirm')?.value">Hasła muszą być takie same.</mat-error>
                    <span class="block" [ngClass]="{'text-success': newPasswordForm.get('password')?.value === newPasswordForm.get('password_confirm')?.value, 'text-danger': newPasswordForm.get('password')?.value !== newPasswordForm.get('password_confirm')?.value}">Hasła muszą być takie same.</span><br>
                 </div>
            </mat-form-field>

            
            <div class="button">
                <button style="width:100%;" type="submit" mat-flat-button color="tertiary" appearance="outline"
                    [disabled]="!newPasswordForm.valid">Resetuj hasło</button>
            </div>
        </form>
    </div>
    <div class="rekbot-img flex-grow-1"></div>
</div>